import { selectArticleColoredIsoItems } from "../ViewerRedux/articleColoredSceneSelectors";
import { selectRoomSectionCenterCoordinate } from "./roomSectionCenterSelectors";
import React from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { useGetMcbimSingleMcbimSpaceQuery, usePostMcbimItemsQuery } from "../../openapi";
import { selectGetActiveFullMcbimSpaceArgs } from "../McBim/mcbimSelectors";
import { RoomSectionViewsPanelContent } from "./RoomSectionViewsPanelContent";
import { selectHttpActiveFullMcbimSpace } from "../McBim/mcbimSelectors";
import { selectRoomSectionPerimeterItemsArgs } from "./roomSectionPerimeterSelectors";
import {
  selectSelectedSection,
  setSelectedSectionInRedux,
  type IViewerSelectedSection,
} from "../ViewerRedux/viewerSlice";

export const RoomSectionsPanel: React.FC = () => {
  const dispatch = useAppDispatch();
  const activeMcbimSpaceArgs = useAppSelector(selectGetActiveFullMcbimSpaceArgs);
  const mcbimSpace = useAppSelector(selectHttpActiveFullMcbimSpace);
  const renderItems = useAppSelector(selectArticleColoredIsoItems);
  const sectionCenterCoordinate = useAppSelector(selectRoomSectionCenterCoordinate);
  const selectedSection = useAppSelector(selectSelectedSection);
  const perimeterItemsArgs = useAppSelector(selectRoomSectionPerimeterItemsArgs);

  useGetMcbimSingleMcbimSpaceQuery(activeMcbimSpaceArgs ?? skipToken);
  usePostMcbimItemsQuery(perimeterItemsArgs ?? skipToken);

  return (
    <RoomSectionViewsPanelContent
      mcbimSpace={mcbimSpace}
      renderItems={renderItems}
      sectionCenterCoordinate={sectionCenterCoordinate}
      selectedSection={selectedSection}
      onSelectedSectionChange={(section) =>
        dispatch(setSelectedSectionInRedux(section as IViewerSelectedSection))
      }
      showVisible2dToggle
    />
  );
};
